var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordianClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59413 7.66521L14.6813 1.77913C14.7823 1.68245 14.8624 1.56743 14.9171 1.44071C14.9718 1.31398 15 1.17805 15 1.04077C15 0.903483 14.9718 0.767556 14.9171 0.64083C14.8624 0.514103 14.7823 0.399084 14.6813 0.302408C14.4795 0.108717 14.2064 -3.46898e-08 13.9218 -4.71312e-08C13.6371 -5.95727e-08 13.3641 0.108717 13.1622 0.302408L7.77533 5.45013L2.44231 0.302407C2.24045 0.108717 1.96739 -5.69673e-07 1.68276 -5.82115e-07C1.39814 -5.94556e-07 1.12507 0.108717 0.923214 0.302407C0.821414 0.398721 0.740427 0.513578 0.684946 0.640321C0.629465 0.767065 0.600594 0.903175 0.600001 1.04077C0.600594 1.17836 0.629465 1.31447 0.684946 1.44121C0.740427 1.56796 0.821414 1.68281 0.923214 1.77913L7.01039 7.66521C7.11128 7.77077 7.23372 7.85501 7.37001 7.91263C7.5063 7.97025 7.65348 8 7.80226 8C7.95105 8 8.09823 7.97025 8.23451 7.91263C8.3708 7.85501 8.49325 7.77077 8.59413 7.66521Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianClosed);
export default __webpack_public_path__ + "static/media/accordian-closed.f5062465b820d233adfb5bd1526f3ddf.svg";
export { ForwardRef as ReactComponent };